import { render, staticRenderFns } from "./AssetsMap.vue?vue&type=template&id=b43f9540&"
import script from "./AssetsMap.vue?vue&type=script&lang=js&"
export * from "./AssetsMap.vue?vue&type=script&lang=js&"
import style0 from "./AssetsMap.vue?vue&type=style&index=0&id=b43f9540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports